import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import type { LinkProps } from '../Link'

export default (config: {
  props: Pick<LinkProps, 'size' | 'discrete'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      link: {
        textDecoration: 'underline',

        '&:active': {
          textDecoration: 'underline',
        },

        ...(props.discrete && {
          ...(props.size === 'small' ? tokens.fontBodyS : tokens.fontBodyM),
          alignItems: 'center',
          display: 'inline-flex',
          textDecoration: 'none',
          height: props.size === 'small' ? tokens.ctaSizeSm : tokens.ctaSizeMd,

          [isTouchScreen]: {
            height: tokens.ctaSizeLg,
          },
        }),
      },

      icon: {
        display: 'inline-flex',
        paddingInlineStart: tokens.spacingGap50,
        verticalAlign: props.discrete ? 'bottom' : 'middle',

        '> svg': {
          height: props.discrete ? 'initial' : '20px',
          width: props.discrete ? 'initial' : '20px',
        },
      },
    },
  } as const
}
